import * as React from 'react';

import { requestPost } from '../../../../modules/request/index';
import { Checkbox } from '../../../Shared';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

interface RemoveStudentsModalProps {
  classroom: any;
  close: () => void;
  onSuccess: (message: string) => void;
  selectedStudentIds: any;
}

const RemoveStudentsModal: React.FC<RemoveStudentsModalProps> = ({ classroom, close, onSuccess, selectedStudentIds }) => {
  const { modalRef, } = useModalAccessibility(close)
  
  const [checkboxOne, setCheckboxOne] = React.useState<boolean>(false);

  const studentOrStudents = (): string =>
    selectedStudentIds.length === 1 ? 'student' : 'students';

  const removeStudents = () => {
    requestPost(
      `/teachers/classrooms/${classroom.id}/remove_students`,
      { student_ids: selectedStudentIds },
      (body: any) => {
        const studentOrStudentsText =
          selectedStudentIds.length === 1 ? 'Student' : 'Students';
        const successMessage = `${studentOrStudentsText} removed`;
        onSuccess(successMessage);
        close();
      }
    );
  };

  const submitButtonClass = (): string => {
    let buttonClass = 'quill-button contained red medium focus-on-light';
    if (!checkboxOne) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  };

  const toggleCheckbox = () => {
    setCheckboxOne((prev) => !prev);
  };

  const numberOfSelectedStudents = selectedStudentIds.length;

  return (
    <div className="modal-container remove-students-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="removeStudentsModalTitle"
        aria-modal="true"
        className="remove-students-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="removeStudentsModalTitle">
            Remove {numberOfSelectedStudents} {studentOrStudents()} from your class?
          </h3>
        </div>
        <p>
          Students' Quill accounts will remain active. If you bring students back into the
          class, the data from their completed activities will be restored.
        </p>
        <div className="checkboxes">
          <Checkbox
            label="I understand that I will no longer have access to the students’ work or data."
            onClick={toggleCheckbox}
            selected={checkboxOne}
          />
        </div>
        <div className="form-buttons">
          <button
            className="quill-button outlined green medium focus-on-light"
            onClick={close}
            type="button"
          >
            Cancel
          </button>
          <button
            className={submitButtonClass()}
            onClick={removeStudents}
            type="button"
          >
            Remove from class
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveStudentsModal;
